<template>
  <section
    class="relative w-full overflow-hidden bg-cover bg-left bg-no-repeat"
    :style="bannerStyle"
  >
    <div class="container-wrap flex h-mobile-banner py-2 tablet:h-banner">
      <div class="flex w-full flex-col justify-center">
        <div>
          <h1 class="text-h1 banner-title mb-2">
            {{ t('title') }}
          </h1>
          <p class="banner-description is-mobile-hidden">
            {{ t('description') }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t } = useI18n({ useScope: 'local' });
  const { blobDomain } = useWebsite();
  const { isCN } = useLanguage();

  const bannerStyle = computed((): string => {
    const imageUrl = isCN.value
      ? `${blobDomain.value}/wise-paas-marketplace/contact-us/contact-us_tech-support_banner.webp`
      : `${blobDomain.value}/wise-paas-marketplace/contact-us/banner.webp`;

    return `background-image: url(${imageUrl})`;
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "We're here to offer technical support",
    "description": "Tell us about your issues so we can get you to the right people, as soon as possible."
  },
  "en-jp": {
    "title": "We're here to offer technical support",
    "description": "Tell us about your issues so we can get you to the right people, as soon as possible."
  },
  "en-tw": {
    "title": "We're here to offer technical support",
    "description": "Tell us about your issues so we can get you to the right people, as soon as possible."
  },
  "en-kr": {
    "title": "We're here to offer technical support",
    "description": "Tell us about your issues so we can get you to the right people, as soon as possible."
  },
  "en-americas": {
    "title": "We're here to offer technical support",
    "description": "Tell us about your issues so we can get you to the right people, as soon as possible."
  },
  "en-asia-pacific": {
    "title": "We're here to offer technical support",
    "description": "Tell us about your issues so we can get you to the right people, as soon as possible."
  },
  "en-emea": {
    "title": "We're here to offer technical support",
    "description": "Tell us about your issues so we can get you to the right people, as soon as possible."
  },
  "ja-jp": {
    "title": "テクニカルサポートを提供します",
    "description": "お客様のお悩みをお聞かせいただければ、適切な担当者が迅速に対応いたします"
  },
  "zh-cn": {
    "title": "我们将提供您技术上的支持",
    "description": "请清楚说明您的问题，我们将尽快将您转接至正确的单位"
  },
  "zh-tw": {
    "title": "我們將提供您技術上的支援",
    "description": "請提交您的問題，以便我們盡快為您找到合適的人協助您"
  }
}
</i18n>
